export default {
    APP_ENV: "production",
    APP_VERSION: "fc3d40e24875052d9b1701675590378caf030892",
    JOBILLA_API_ROOT: "https://api.jobilla.com/",
    JOBILLA_API_V2_URL: "https://api.jobilla.com/api/v2/",
    FORM_REVALIDATE_SECRET: "jobilla-is-best",
    ASSETS_URL: "https://images.jobilla.com/",
    IMAGES_URL: "https://storage.googleapis.com/jobillaweb-production-uploads/",
    NOTIFICATIONS_API: "https://api.jobilla.com/notifications/",
    JOBILLA_URL: "https://tas.app.jobilla.com/",
    LOGIN_URL: "https://auth.app.jobilla.com/login/",
    TAS_V2_URL: "https://tas-beta.app.jobilla.com/",
    LEGACY_USER_SPA_URL: "https://api.jobilla.com/account/",
    CALLBACK_URL: "https://auth.jobilla.com/auth/facebook/callback/",
    JOBILLA_COMPANY_ID: 'JobillaCompany',
    JOBILLA_AUTH_TOKEN: 'JobillaOAuthToken',
    JOBILLA_AUTH_REFRESH_TOKEN: 'JobillaOAuthRefreshToken',
    ATTACHMENT_URL: "https://api.jobilla.com/uploads/user/attachment/",
    JOBILLA_BUSINESS_URL: 'https://yrityksille.jobilla.com',
    ROOT_DOMAIN: "jobilla.com",

    FORM_VIEWER_URL: "https://questionnaires.jobilla.com/",
    V3_FORM_VIEWER_URL: "https://forms.jobilla.com/",
    DEFAULT_LANGUAGE: 'en-GB',

    OAUTH_CLIENT_ID: "2",
    OAUTH_CLIENT_SECRET: "HS1WXY8uZg05TOurHv8C0l3UzSX3fckFd0Y1iJBD",

    BUGSNAG_API_KEY: "c26e0d46ef43dc8a333d53b5e8eb2952",
    DATADOG_TOKEN: "",

    AD_GENERATION_URL: "https://campaign-generation.app.jobilla.com/",
    AD_GENERATION_TOKEN: "tas:FKau7N3rjhxtQiCt6610CwER",

    MATOMO_HOST: "",
    MATOMO_CDN_URL: "",
    MATOMO_SITE_ID: "",

    POSTHOG_API_KEY: "phc_bQlNfK1S7STlO0bOEM0BQqZjNAB23KagtFiZJXw0Jul",
    POSTHOG_HOST: "https://eu.posthog.com",
    VUE_APP_JOBIBOT_LANDING_PAGE_ASSISTANT_URL: "https://aquinas.jobilla.com",

    GAPI_ID: "",
    INTERCOM_API_KEY: "xwbr0bg3",
    USERIQ_SITE_ID: "",

    APPS: {
        EB: {
            URL: "https://api.jobilla.com/company/eb/",
        },
        TARGET: {
            URL: "https://target.jobilla.com/",
        },
        CANDIDATE_POOL: {
            URL: "https://tas.app.jobilla.com/candidates/",
        },
        SETTINGS: {
            URL: "https://tas.app.jobilla.com/settings/",
        },
        DASHBOARD: {
            URL: "https://tas.app.jobilla.com/",
        },
        FORM_VIEWER: {
            URL: "https://questionnaires.jobilla.com/",
        },
        V3_FORM_VIEWER: {
            URL: 'https://forms.jobilla.com/',
        },
        PRIVACY: {
            CANDIDATE_URL: (locale, companyId) => 'https://privacy.jobilla.com/{LOCALE}/{COMPANY}/'
                .replace('{LOCALE}', locale)
                .replace('{COMPANY}', companyId),
            CUSTOMER_URL: (locale = 'en-GB') => 'https://www.jobilla.com/{LOCALE}/legal/'.replace('{LOCALE}', locale.substring(0, 2)),
        },
        NOTIFICATIONS: {
            URL: "https://tas.app.jobilla.com/notifications/",
        },
        PRODUCT: {
            URL: "https://tas.app.jobilla.com/",
        },
        PUBLIC: {
            URL: "https://public.jobilla.com/",
        },
        ADMIN: {
            URL: "https://admin.app.jobilla.com/",
        },
    },

    PAGES: {
        DATA_PROTECTION_POLICY: {
            PATH: 'data-protection-policy',
        },
        PRIVACY_POLICY: {
            PATH: 'privacy-policy',
        },
        TERMS_AND_CONDITIONS: {
            PATH: 'terms-and-conditions',
        },
    },


    CONTACT: {
        address: {
            company: 'Jobilla Oy',
            street: 'Vilhonkatu 4',
            postal_code: '00100',
            city: 'Helsinki',
            country: 'Finland',
        },
        phone: '+358 45 278 4844',
        email: 'cs-finland@jobilla.com',
        vat_number: '2655898-5',
        customer_service_phone: '+358 40 187 5214'
    },

    SETTINGS: {
        TEMPLATES: {
            RECEIVED: 1,
        },
    },

    KNOWLEDGE_BASE: {
        CANDIDATE_ATTRIBUTES: {
            EN: 'http://help.jobilla.com/en/scoring-and-identifying-candidates-with-candidate-attributes',
            FI: 'https://help.jobilla.com/fi/kandidaattien-osaamisen-tunnistaminen-ja-pisteytys-kandidaattien-ominaisuuksien-avulla',
        },
        ARCHIVING_RECRUITMENT: {
            EN: 'https://help.jobilla.com/en/adjusting-recruitment-visibility',
            FI: 'https://help.jobilla.com/fi/s%C3%A4%C3%A4d%C3%A4-rekrytoinnin-n%C3%A4kyvyytt%C3%A4',
        },
    },
};
